import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type { ApiResponse, HomeData } from "../interface";

export const homeService = {
  async getHomeData() {
    return cachedGet<ApiResponse<HomeData>>(
      API_ENDPOINTS.home
    );

  },
};
